<template>
	<div class="relative">
		<div class="dark:bg-white dark:text-black bg-black text-white font-bold absolute rounded-full text-center w-5 h-5">
			<span class="inline-block pt-[1.5px]"><Icon type="mention" size="sm"></Icon></span>
		</div>
	</div>
</template>
